/*
 * The shared settings layout primitives now live at
 * Settings/Components/settingsLayout.tsx so that every device settings tab
 * (not just the GX-8 tabs) can share one visual language. This module
 * re-exports them to keep the existing GX-8 tab imports stable.
 */
export * from "../../../Components/settingsLayout";